import { initialize } from 'redux-form';
import { FORM_NAME } from '../components/DemoEdgeControllerDetailsForm/DemoEdgeControllerDetailsForm';

export const GET_EDGE_CONTROLLER_DETAILS = 'GET_EDGE_CONTROLLER_DETAILS';
export const GET_EDGE_CONTROLLER_DETAILS_SUCCESS = 'GET_EDGE_CONTROLLER_DETAILS_SUCCESS';
export const GET_EDGE_CONTROLLER_DETAILS_FAILURE = 'GET_EDGE_CONTROLLER_DETAILS_FAILURE';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_ACTIVE_EDGE_CONTROLLER = 'SET_ACTIVE_EDGE_CONTROLLER';
export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
export const TOGGLE_ERROR_SNACKBAR = 'TOGGLE_ERROR_SNACKBAR';
export const TOGGLE_REINIT_FORM = 'TOGGLE_REINIT_FORM';
export const UPDATE_EDGE_CONTROLLER = 'UPDATE_EDGE_CONTROLLER';
export const UPDATE_EDGE_CONTROLLER_SUCCESS = 'UPDATE_EDGE_CONTROLLER_SUCCESS';
export const UPDATE_EDGE_CONTROLLER_FAILURE = 'UPDATE_EDGE_CONTROLLER_FAILURE';

export const edgeControllerRequest = () => ({
  type: GET_EDGE_CONTROLLER_DETAILS,
});

export const setActiveEdgeController = (edgeController) => ({
  type: SET_ACTIVE_EDGE_CONTROLLER,
  edgeController,
});

export const getEdgeControllerDetailsSuccess = (data) => ({
  type: GET_EDGE_CONTROLLER_DETAILS_SUCCESS,
  payload: data,
});

export const toggleSnackbar = (flag) => ({
  type: TOGGLE_SNACKBAR,
  flag,
});

export const toggleErrorSnackbar = (flag, error = null) => ({
  type: TOGGLE_ERROR_SNACKBAR,
  flag,
  error,
});

export const toggleReinitForm = (flag) => ({
  type: TOGGLE_REINIT_FORM,
  flag,
});

export const initViewEditForm = (data) => (dispatch) => {
  const processedData = { ...data };

  dispatch(initialize(FORM_NAME, processedData));
  dispatch(setActiveEdgeController(processedData));
};

export const getEdgeControllerDetails =
  (edgeControllerId, edgeControllers = []) =>
  (dispatch) => {
    dispatch(edgeControllerRequest());

    // TODO: Replace with actual API endpoint
    return new Promise((resolve) => {
      setTimeout(() => {
        const mockData = edgeControllers.find((ec) => ec.edgeControllerId === edgeControllerId) || {
          edgeControllerId,
          name: 'Unknown Edge Controller',
          online: false,
          firmwareVersion: 'N/A',
          customerName: 'N/A',
          plazaName: 'N/A',
          customerId: null,
          plazaId: null,
        };

        dispatch(getEdgeControllerDetailsSuccess(mockData));
        dispatch(initViewEditForm(mockData));
        dispatch(toggleReinitForm(true));
        resolve(mockData);
      }, 700);
    });
  };

export const updateEdgeController = (edgeControllerBody) => (dispatch) => {
  dispatch({ type: UPDATE_EDGE_CONTROLLER });

  // TODO: Replace with actual API endpoint
  return new Promise((resolve) => {
    setTimeout(() => {
      dispatch(initViewEditForm(edgeControllerBody));
      dispatch(toggleSnackbar(true));
      dispatch(toggleReinitForm(true));
      dispatch({ type: UPDATE_EDGE_CONTROLLER_SUCCESS });
      resolve(edgeControllerBody);
    }, 700);
  });
};

export const setActiveTab = (tab, navigate, ownProps) => (dispatch) => {
  const { match, location } = ownProps;
  const edgeControllerId = match.params.edgeControllerId;

  if (navigate) {
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.toString();
    const path = `/demoEdge/controllers/details/${edgeControllerId}/${tab}${queryString ? `?${queryString}` : ''}`;
    navigate(path);
  }

  dispatch({
    type: SET_ACTIVE_TAB,
    payload: tab,
  });
};
